import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MsalModule } from '@azure/msal-angular';
import { TegelModule } from '@scania/tegel-angular-17';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, TegelModule, MsalModule],
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
  title = 'dcp-role-app';
}
